import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupIntersect: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-intersect"><path d="M8.75 5.5V2.75H21.25V15.25H18.5M8.75 8.75V15.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 15.25V8.75H8.75M5.5 8.75H2.75V21.25H15.25V18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBooleanGroupIntersect;
